/**
 * Various scroll related utils.
 */
const scroll = {
  SCROLL_UP: "up",
  SCROLL_DOWN: "down",
  SCROLL_LEFT: "left",
  SCROLL_RIGHT: "right",

  /**
   * @param {event.<DOMMouseScroll>} event
   * @return {string}
   */
  getDirectionDOMMouseScroll(event) {
    if (event.detail < 0) {
      return this.SCROLL_UP;
    }
    return this.SCROLL_DOWN;
  },

  /**
   * @param  {event.<wheel>} event
   * @return {string}
   */
  getDirectionMousewheel(event) {
    if (event.wheelDeltaX) {
      return event.wheelDeltaX > 0 ? this.SCROLL_LEFT : this.SCROLL_RIGHT;
    }
    return event.wheelDeltaY > 0 ? this.SCROLL_UP : this.SCROLL_DOWN;
  },

  /**
   * Get scroll direction
   * @param  {event.<DOMMouseScroll>|event.<wheel>} event
   * @return {string|null}
   */
  getDirection(event) {
    const e = event.originalEvent || event; // support binding via vanilla||jquery
    if (e.type === "DOMMouseScroll") {
      return this.getDirectionDOMMouseScroll(e);
    }
    if (e.type === "wheel") {
      return this.getDirectionMousewheel(e);
    }
    return null;
  },
};

export default scroll;
